<p-toast></p-toast>
<aud-loader></aud-loader>
<p-confirmDialog key="delete" [header]="'CRUD.CONFIRM_DELETE_HEADER' | translate" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<aud-app-header></aud-app-header>
<div class="aud-ml-230">
    <router-outlet></router-outlet>
</div>
